import * as actionType from "../../constants";
import * as commonData from "../../Common";

export const userApiCall = (inputs) => async (dispatch) => {
  const url = commonData.commonData().apiUrl;
  try {
    const responsedata = await fetch(
      `${url}get-all-users?app_token=${commonData.commonData().appToken}`
    );
    const rdata = await responsedata.json();

    dispatch({
      type: actionType.USER_API_CALL,
      payload: rdata,
    });
  } catch (error) {
    console.log(error.message);
  }
};
